export default __webpack_public_path__ + "static/media/distance.6efa5c6c.png";